var React = require('react');

function ContainerStorage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M16 96v320h608V96zm96 288H80V128h32zm112 0h-32V128h32zm112 0h-32V128h32zm112 0h-32V128h32zm112 0h-32V128h32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M624 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-384H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

ContainerStorage.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ContainerStorage;

ContainerStorage.default = ContainerStorage;
